<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/tramite-carga">Trámites</router-link> >
            <router-link :to="'/tramiteform-carga/' + this.p_idTramite"
              >Trámite {{ p_idTramite }}</router-link
            >
            > Carga {{ p_idCarga }}
          </div>
        </div>
        <div class="col-1">
          <span
            class="material-symbols-outlined"
            style="font-size: 32px; color: blue; cursor: pointer"
            @click="showModalHelp = true"
          >
            help
          </span>
        </div>
      </div>
    </div>

    <Modal v-model:modelValue="showModalHelp">
      <AyudaTramiteForm />
    </Modal>
    <hr />

<!-- Botones de exportación -->
<div class="row mb-3">
  <div class="col-auto">
    <button class="btn btn-success" @click="exportToCSV">
      Exportar a CSV
    </button>
  </div>
  <div class="col-auto">
    <button class="btn btn-danger" @click="exportToPDF">
      Exportar a PDF
    </button>
  </div>
  <div class="col-auto">
    <button class="btn btn-info" @click="printTable">
      Imprimir
    </button>
  </div>
</div>

    <!-- Tabla -->
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col">Número</th>
          <th scope="col">Cédula</th>
          <th scope="col">Nombre</th>
          <th scope="col">Errores</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="cargaplanilla in datosPaginados"
          :key="cargaplanilla.idCargaPlanilla"
        >
          <td>{{ cargaplanilla.numero }}</td>
          <td>{{ cargaplanilla.cedula }}</td>
          <td>{{ cargaplanilla.nombre }}</td>
          <td><p v-html="cargaplanilla.detalleErrores"></p></td>
        </tr>
      </tbody>
  <tfoot>
    <tr>
      <td colspan="4" class="text-end">
        <b>Total registros: {{ cargaplanillas.length }}</b>
      </td>
    </tr>
  </tfoot>
    </table>
    <div class="d-flex justify-content-center">
      <nav aria-label="Page navigation">
        <ul class="pagination">
          <li
            class="page-item"
            :class="{ disabled: paginaActual === 1 }"
            @click="irPrimeraPagina"
          >
            <a class="page-link" href="#">«</a>
          </li>
          <li
            class="page-item"
            :class="{ disabled: paginaActual === 1 }"
            @click="getPreviousPage"
          >
            <a class="page-link" href="#">‹</a>
          </li>

          <li class="page-item active">
            <a class="page-link" href="#">{{ paginaActual }}</a>
          </li>

          <li
            class="page-item"
            :class="{ disabled: paginaActual === totalPaginas() }"
            @click="getNextPage"
          >
            <a class="page-link" href="#">›</a>
          </li>
          <li
            class="page-item"
            :class="{ disabled: paginaActual === totalPaginas() }"
            @click="irUltimaPagina"
          >
            <a class="page-link" href="#">»</a>
          </li>
        </ul>
      </nav>
    </div>
    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;

export default {
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      cargaplanillas: [],
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      p_idTramite: 0,
      p_idCarga: 0,
    };
  },
  mounted() {
    this.p_idTramite = this.$route.params.p_idtramite;
    this.p_idCarga = this.$route.params.p_idcarga;
    this.getDataPagina(this.paginaActual);
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },
  methods: {
    totalPaginas() {
      return Math.ceil(this.cargaplanillas.length / this.elementosPorPagina);
    },
    getDataPagina(noPagina) {
      api.get(`/vwcargaplanillas/errores/${this.p_idTramite}/${this.p_idCarga}`
        )
        .then((response) => {
          this.cargaplanillas = response.data;
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.cargaplanillas.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    irPrimeraPagina() {
      this.paginaActual = 1;
      this.getDataPagina(this.paginaActual);
    },
    irUltimaPagina() {
      this.paginaActual = this.totalPaginas();
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    // Método para imprimir la tabla
    printTable() {
      const printContent = document.getElementById("sampleTable").outerHTML;
      const printWindow = window.open("", "", "height=600,width=800");
      printWindow.document.write(
        "<html><head><title>Imprimir Tabla</title></head><body>"
      );
      printWindow.document.write(printContent);
      printWindow.document.write("</body></html>");
      printWindow.document.close();
      printWindow.print();
    },

    // Método para exportar a CSV
    exportToCSV() {
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += "Número;Cédula;Nombre;Errores\n"; // Encabezados

      this.cargaplanillas.forEach((cargaplanilla) => {
        let erroresLimpios = cargaplanilla.detalleErrores.replace(
          /<\/?[^>]+(>|$)/g,
          ""
        ); // Eliminar etiquetas HTML
        let row = `${cargaplanilla.numero};${cargaplanilla.cedula};${cargaplanilla.nombre};"${erroresLimpios}"`;
        csvContent += row + "\n";
      });

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `carga_planilla_${this.p_idCarga}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
exportToPDF() {
  const doc = new jsPDF(); // Crea instancia correctamente

  const headers = [["Número", "Cédula", "Nombre", "Errores"]];
  const rows = this.cargaplanillas.map((item) => {
    const erroresLimpios = item.detalleErrores.replace(/<\/?[^>]+(>|$)/g, "");
    return [item.numero, item.cedula, item.nombre, erroresLimpios];
  });

  // ✅ Llama autoTable directamente con el doc
  autoTable(doc, {
    startY: 20,
    head: headers,
    body: rows,
  });

  doc.save(`carga_planilla_${this.p_idCarga}.pdf`);
}
  },
};
</script>
